import { z } from 'zod';
import { EngagementStatus } from './onboarding-enums.js';

// A single referred engagement (engagement-grain): the referred person, their
// own business vendor, and the client engagement — surfaced under the referrer
// that sent them (T-155). Read-only aggregation over engagements.referred_by_vendor_id.
export const ReferredResource = z.object({
  engagement_id: z.string().uuid(),
  resource_id: z.string().uuid(),
  resource_name: z.string(),
  // The referred person's OWN business vendor (distinct from the referrer).
  vendor_id: z.string().uuid(),
  business_name: z.string(),
  client_name: z.string().nullable(),
  product_service: z.string(),
  status: EngagementStatus,
});
export type ReferredResource = z.infer<typeof ReferredResource>;

// One referrer vendor and everyone it referred.
export const ReferrerGroup = z.object({
  vendor_id: z.string().uuid(),
  business_name: z.string(),
  referred: z.array(ReferredResource),
});
export type ReferrerGroup = z.infer<typeof ReferrerGroup>;

// GET /api/referrals — the whole referrals view.
export const ReferralsResponse = z.object({
  referrers: z.array(ReferrerGroup),
});
export type ReferralsResponse = z.infer<typeof ReferralsResponse>;

// GET /api/vendors/:id/referred — just this referrer's list, for the vendor-
// detail "Referred resources" section.
export const VendorReferredResponse = z.object({
  referred: z.array(ReferredResource),
});
export type VendorReferredResponse = z.infer<typeof VendorReferredResponse>;
